module.exports = __webpack_public_path__ + "static/media/unwanted-buyers.a9f4ef72.jpg";